import { useState, useMemo } from 'react'
import { Dropdown } from 'components/Input'
import { DropdownOption } from 'components/Input/Dropdown'

import {
  mistSiteIdSelector,
  mistSiteFetchDataSelector,
} from 'features/networkAi/selectors'
import { useAppSelector } from 'app/hooks'
import { useNetworkOrgId } from 'features/networkAi/hooks'
import DataCard from './DataCard'
import NetworkSelector from './NetworkSelector'
import { SpinnerCentered } from 'components/Loader'
import {
  MonitoringGroupView,
  HeadersFrame,
  MonitoringFrame,
  MonitoringText,
  NetworkGraphContainer,
  DurationFrame,
  InputMaster,
  InputBorder,
} from './styles'

const GRAPH_RANGE_OPTIONS = [
  { value: 43200, label: 'Today' },
  { value: 86400, label: '24 Hours' },
  { value: 604800, label: 'Last 7 Days' },
]

const GraphRangeOptions = GRAPH_RANGE_OPTIONS.map((option) => ({
  label: option.label,
  value: option.value,
}))

function MonitoringGroup() {
  const orgId = useNetworkOrgId()
  const siteId: string = useAppSelector(mistSiteIdSelector)
  const isSiteLoaded = useAppSelector(mistSiteFetchDataSelector.isFinished)
  const [duration, setDuration] = useState(43200)

  const valueDuration = useMemo(
    () =>
      GraphRangeOptions.find((option) => option.value === duration) || {
        label: `${duration} `,
        value: duration,
      },
    [duration]
  )

  const DurationSelector = () => {
    return (
      <DurationFrame>
        <InputMaster>
          <InputBorder>
            <Dropdown
              options={GraphRangeOptions}
              name="graphRange"
              value={valueDuration}
              placeholder=""
              onChange={(option: DropdownOption) =>
                setDuration(Number(option.value))
              }
            />
          </InputBorder>
        </InputMaster>
      </DurationFrame>
    )
  }

  return (
    <>
      {!isSiteLoaded ? (
        <SpinnerCentered size="40" />
      ) : (
        <MonitoringGroupView>
          <HeadersFrame>
            <MonitoringFrame>
              <MonitoringText>Network Health</MonitoringText>
            </MonitoringFrame>
            <DurationSelector />
          </HeadersFrame>

          <NetworkGraphContainer>
            <NetworkSelector />

            <DataCard
              title="Time to Connect"
              siteId={siteId}
              metric="time-to-connect"
              duration={duration}
              orgId={orgId}
            ></DataCard>
            <DataCard
              title="Successful Connects"
              siteId={siteId}
              metric="failed-to-connect"
              duration={duration}
              orgId={orgId}
            ></DataCard>
            <DataCard
              title="Coverage"
              siteId={siteId}
              metric="coverage"
              duration={duration}
              orgId={orgId}
            ></DataCard>
            <DataCard
              title="Roaming"
              siteId={siteId}
              metric="roaming"
              duration={duration}
              orgId={orgId}
            ></DataCard>
            <DataCard
              title="Throughput"
              siteId={siteId}
              metric="throughput"
              duration={duration}
              orgId={orgId}
            ></DataCard>
            <DataCard
              title="Capacity"
              siteId={siteId}
              metric="capacity"
              duration={duration}
              orgId={orgId}
            ></DataCard>
            <DataCard
              title="AP Health"
              siteId={siteId}
              metric="ap-health"
              duration={duration}
              orgId={orgId}
            ></DataCard>
          </NetworkGraphContainer>
        </MonitoringGroupView>
      )}
    </>
  )
}

export default MonitoringGroup
